<hard-modal
  [title]="'base.contactSupportTeam' | hardTranslate"
  [icon]="'icon-wo-count'"
  (closeModal)="close()"
>
  <div class="flex flex-col gap-5 p-2 min-w-[380px]">
    <div class="flex flex-col gap-2">
      <span class="text-sm font-semibold text-[var(--text-color)]">
        {{ "base.techSupportService" | hardTranslate }}
      </span>
      <a
        [href]="'mailto:' + supportEmail"
        class="flex items-center gap-2 text-[var(--dt-primary)] hover:underline text-sm font-medium w-fit"
      >
        <span class="icon-email text-base"></span>
        {{ supportEmail }}
      </a>
    </div>

    <div class="h-px bg-[var(--border-color)]"></div>

    <div class="flex flex-col gap-2">
      <span class="text-sm font-semibold text-[var(--text-color)]">
        {{ "base.portalAdministrators" | hardTranslate }}
      </span>
      <div class="flex flex-col gap-2">
        @for (email of adminEmails; track email) {
          <a
            [href]="'mailto:' + email"
            class="flex items-center gap-2 text-[var(--dt-primary)] hover:underline text-sm font-medium w-fit"
          >
            <span class="icon-email text-base"></span>
            {{ email }}
          </a>
        }
      </div>
    </div>
  </div>
</hard-modal>
